import React from 'react';
import PropTypes from 'prop-types';
import './OpportunitiesLogos.scss';

const OpportunitiesLogos = props => {
  const { logos } = props;

  const displayLogos = logos.slice(0, 5);

  return (
    <div className='opportunities-logos-outer-container'>
      <div className='opportunities-logos-inner-container'>
        {displayLogos.map((logo, i) => (
          <img style={{ zIndex: logos.length - i }} className='opportunities-logo' src={logo} alt={'Brand Logo'} />
        ))}
        {logos.length > 5 && <div className='opportunities-logos-extra'>{`+${logos.length - 5}`}</div>}
      </div>
      <div className='opportunities-logos-subtitle'>Your Current Brand Opportunities</div>
    </div>
  );
};

OpportunitiesLogos.propTypes = {
  logos: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OpportunitiesLogos;
